export const SHADOW_COLOR = "rgb(20, 20, 20)"

export const SHADOWS = {
  $0: {
    elevation: 1,
    shadowColor: SHADOW_COLOR,
    shadowOffset: {
      height: 1,
      width: 0,
    },
    shadowOpacity: 0.18,
    shadowRadius: 1,
  },
  $1: {
    elevation: 2,
    shadowColor: SHADOW_COLOR,
    shadowOffset: {
      height: 1,
      width: 0,
    },
    shadowOpacity: 0.2,
    shadowRadius: 1.41,
  },
  $2: {
    elevation: 3,
    shadowColor: SHADOW_COLOR,
    shadowOffset: {
      height: 1,
      width: 0,
    },
    shadowOpacity: 0.22,
    shadowRadius: 2.22,
  },
  $3: {
    elevation: 4,
    shadowColor: SHADOW_COLOR,
    shadowOffset: {
      height: 2,
      width: 0,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
  },
  $4: {
    elevation: 5,
    shadowColor: SHADOW_COLOR,
    shadowOffset: {
      height: 2,
      width: 0,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
  },
  $5: {
    elevation: 6,
    shadowColor: SHADOW_COLOR,
    shadowOffset: {
      height: 3,
      width: 0,
    },
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
  },
  $6: {
    elevation: 7,
    shadowColor: SHADOW_COLOR,
    shadowOffset: {
      height: 3,
      width: 0,
    },
    shadowOpacity: 0.29,
    shadowRadius: 4.65,
  },
  $7: {
    elevation: 8,
    shadowColor: SHADOW_COLOR,
    shadowOffset: {
      height: 4,
      width: 0,
    },
    shadowOpacity: 0.3,
    shadowRadius: 4.65,
  },
  $8: {
    elevation: 9,
    shadowColor: SHADOW_COLOR,
    shadowOffset: {
      height: 4,
      width: 0,
    },
    shadowOpacity: 0.32,
    shadowRadius: 5.46,
  },
  $9: {
    elevation: 10,
    shadowColor: SHADOW_COLOR,
    shadowOffset: {
      height: 5,
      width: 0,
    },
    shadowOpacity: 0.34,
    shadowRadius: 6.27,
  },
}
